module.exports = __webpack_public_path__ + "069efcc58f0bef416b916cb17e6552f8.png";


//////////////////
// WEBPACK FOOTER
// ./wwwroot/css/images/overlay.png
// module id = 0
// module chunks = 0